module.exports = __webpack_public_path__ + "c6b067a1c77f367c820b2dae16062e1f.svg";